import { PlanInterval } from '../models/plans';

export const isMonthlyPlan = (interval: PlanInterval): boolean => interval === 'P1M';
